import type {
  Credentials,
  LoginError,
  LoginSession,
  StepStatus,
} from '../domain/login.model';

export type LoginPhase = 'credentials' | 'otp';

/**
 * Redux state for the two-step Login flow. The `phase` switches the UI between
 * the credentials form and the OTP form (replacing the original `otpData !==
 * null` check). `otpToken`/`otpEmail` come from the server's step-1 response and
 * live here (unlike reset-password's URL token) because they are produced
 * mid-flow. `session` is the established `{ user, licence }` the page reads and
 * commits into AuthContext. Ephemeral display concerns (showPassword, focus,
 * cooldown ticking, rememberMe persistence) are NOT here. Every field is
 * serialisable.
 */
export interface LoginState {
  phase: LoginPhase;
  credentials: Credentials;
  otp: string[];
  otpToken: string | null;
  otpEmail: string | null;
  credentialsStatus: StepStatus;
  otpStatus: StepStatus;
  resendStatus: StepStatus;
  credentialsError: LoginError | null;
  otpError: LoginError | null;
  /** Throttling cooldown (seconds) from a rate-limited credentials attempt; 0 = none. */
  retryAfter: number;
  session: LoginSession | null;
}

export const emptyOtp: string[] = ['', '', '', '', '', ''];

export const initialState: LoginState = {
  phase: 'credentials',
  credentials: { email: '', password: '' },
  otp: emptyOtp,
  otpToken: null,
  otpEmail: null,
  credentialsStatus: 'idle',
  otpStatus: 'idle',
  resendStatus: 'idle',
  credentialsError: null,
  otpError: null,
  retryAfter: 0,
  session: null,
};
